import { type ColorAndTrimSettingsSpecsFragment } from '../../../../api/fragments/ColorAndTrimSettingsSpecs';
import { type MatrixSpecsFragment } from '../../../../api/fragments/MatrixSpecs';
import { type TranslatedStringDataFragment } from '../../../../api/fragments/TranslatedStringData';
import { type TrimBlockSpecsFragment } from '../../../../api/fragments/TrimBlockSpecs';
import {
    type ColorAndTrimSettingsInput,
    type BlockInput,
    BlockType,
    type ColorBlockInput as ApiColorBlockInput,
} from '../../../../api/types';

export const FORM_NAME = 'variantConfiguratorColorBlocks';

export type ColorSettingFormValues = ColorAndTrimSettingsInput & {
    image?: File | ColorAndTrimSettingsSpecsFragment['image'];
    sectionImages?: {
        trimId: string;
        trimName: TranslatedStringDataFragment;
        variantColorImage?: File | MatrixSpecsFragment['variantColorImage'];
    }[];
};
export type ColorBlockInput = Omit<ApiColorBlockInput, 'colorSettings'> & {
    id?: string;
    colorSettings: ColorSettingFormValues[];
};
export type ColorBlockFormValues = Omit<BlockInput, 'colorBlockInput'> & {
    colorBlockInput: ColorBlockInput;
};

export const getDefaultColorSetting = (trimBlock?: TrimBlockSpecsFragment) => ({
    name: {
        defaultValue: '',
        overrides: [],
    },
    code: '',
    hex: '',
    price: 0,
    sectionImages: trimBlock?.trimSettings.map(trim => ({
        trimId: trim.id,
        trimName: trim.name,
        variantColorImage: undefined,
    })),
});

export const getDefaultColorBlockInput = (trimBlock?: TrimBlockSpecsFragment): ColorBlockInput => ({
    isActive: true,
    colorSettings: [getDefaultColorSetting(trimBlock)],
    sectionTitle: {
        defaultValue: '',
        overrides: [],
    },
});

export const getDefaultColorBlock = (trimBlock?: TrimBlockSpecsFragment): ColorBlockFormValues => ({
    type: BlockType.Color,
    colorBlockInput: getDefaultColorBlockInput(trimBlock),
});
